// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I711g>i{margin-right:.5rem}.N2rad.ui.popup .content{padding-top:0}.N2rad p{font-size:.9rem;margin-bottom:.5em}.N2rad p:last-child{margin-bottom:0}.N2rad .ui.popup h4,.N2rad h4{font-size:1.1rem;font-weight:700;margin:.25rem 0}.N2rad .ui.popup h4:first-child,.N2rad h4:first-child{margin-top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `I711g`,
	"popup": `N2rad`
};
module.exports = ___CSS_LOADER_EXPORT___;
